import { Box, Button, Text, useColorModeValue } from "@chakra-ui/react";
import { RefreshCw } from "lucide-react";
import errorImage from "../assets/teste Bravo celular com notebook de lado casaco puffer.webp";

interface ErrorStateProps {
  title?: string;
  message?: string;
  onRetry?: () => void;
}

export const ErrorState = ({
  title = "Algo deu errado",
  message = "Não foi possível carregar as informações. Verifique sua conexão e tente novamente.",
  onRetry,
}: ErrorStateProps) => {
  const titleColor  = useColorModeValue("gray.700", "gray.100");
  const msgColor    = useColorModeValue("gray.500", "gray.400");

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      py={12}
      gap={4}
      textAlign="center"
    >
      <Box as="img"
        src={errorImage}
        alt="Erro"
        w="180px"
        userSelect="none"
        draggable={false}
      />

      <Box>
        <Text fontSize="md" fontWeight={600} color={titleColor} mb={1}>
          {title}
        </Text>
        <Text fontSize="sm" color={msgColor} maxW="360px">
          {message}
        </Text>
      </Box>

      {onRetry && (
        <Button
          size="sm"
          colorScheme="ggBlue"
          variant="outline"
          leftIcon={<RefreshCw size={14} />}
          onClick={onRetry}
          borderRadius="lg"
        >
          Tentar novamente
        </Button>
      )}
    </Box>
  );
};
